import { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import { Box, InputLabel } from '@mui/material';

import { RadioFormField } from 'types';
import { appendInputIdToLabel } from 'utils';
import { defaultLanguage, useTranslationContext } from 'context';

import { RadioField } from '../fields';

export const FormRadioField = ({
  id,
  label,
  inputId,
  options,
  translations,
}: RadioFormField) => {
  const { language } = useTranslationContext();

  const translation = useMemo(() => {
    if (!language || !translations || language === defaultLanguage) {
      return {
        label: appendInputIdToLabel(label, inputId),
        options: options?.options
          ? options?.options.map((value) => ({ value, label: value }))
          : [],
      };
    }

    const translation = translations[language];
    const langOptions = translation.options || options?.options;
    return {
      label: appendInputIdToLabel(
        label ? translation?.label || label : label,
        inputId
      ),
      options: langOptions
        ? langOptions.map((value, index) => ({
            label: value,
            value: options?.options?.[index] || value,
          }))
        : [],
    };
  }, [label, options?.options, language, translations, inputId]);

  return (
    <Box>
      {translation.label && (
        <InputLabel className="mb-2">{translation.label}</InputLabel>
      )}
      <RadioField
        name={id}
        radioClassName="p-0 mr-2"
        options={translation.options}
        radioGroupClassName={twMerge(
          'flex flex-col gap-4 lg:gap-8',
          translation.options.length > 2 ? 'md:flex-row' : 'flex-row'
        )}
      />
    </Box>
  );
};
